import { useQuery } from '@tanstack/react-query';

import { Declaration, DeclarationStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  status: DeclarationStatus;
}

export const useDeclarationsByBatchIdAndStatus = ({ batchId, status }: HookProps) =>
  useQuery({
    queryKey: ['declarations', batchId, status],
    queryFn: async (): Promise<Declaration[]> => {
      try {
        const result = await apiClient.declarations.retrieveByStatus.query({ params: { id: batchId, status } });
        if (result.status !== 200) throw result.body;

        return result.body.data as Declaration[];
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarations by batch and status');
      }
    },
    placeholderData: [],
  });
